// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1kgZW","footer":"ReportModalFilter_footer__Zse_U"};